










































































































































































































import {Vue, Component} from 'vue-property-decorator'
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class PregledDokumenta extends ComponentBaseMixin {
  order = {};

  async created() {
    await this.load();
  }

  async load() {
    const {data} = await this.$http.get(`/api/GetOrderDetails/${this.$route.params.id}`);
    this.order = data;
  }

  async storno() {
    let da = await this.confirmationNeeded("Da li želite da stornirate izabrani dokument?");
    if (da) {
      try {
        await this.$http.put(`/api/StornoOrder/${this.$route.params.id}`);
        this.showInfo("Narudžbenice je uspešno stornirana");
        await this.load();
      } catch (e) {
        this.showError("Greška prilikom storniranja narudžbenice");
      }
    }
  }

  async realizuj() {
    let da = await this.confirmationNeeded("Da li želite da realizujete izabrani dokument?");
    if (da) {
      try {
        await this.$http.put(`/api/ProcessOrder/${this.$route.params.id}`);
        this.showInfo("Narudžbenice je uspešno realizovana");
        await this.load();
      } catch (e) {
        this.showError("Greška prilikom realizacije narudžbenice");
      }
    }
  }
}
